import React from 'react'
import map from 'lodash/map'
import { Dropdown } from 'react-bootstrap'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { LinkDropdownToggle } from '@ztechapps/webui.data-tools'
import { PortalDropdownMenu } from '@ztechapps/webui.util'
import { buildMoveToMenuModel } from '../../BlogCategory/blogCategoryTree.utils'
import { NO_EDIT_PERMISSION_REASON } from '../../PermissionReasons'
import { useBlogCategoryTreeViewContext } from './Context'

export type MoveToMenuProps = {
  /** Destinations that make no sense for the subject — its own category, or a category's subtree and parent — left out of the menu. */
  excludedBlogCategoryIds?: string[]
  /** The chosen destination's `_id`, or null for the top level. */
  onMove: (categoryId: string | null) => void
}

export const MoveToMenu = ({ excludedBlogCategoryIds = [], onMove }: MoveToMenuProps) => {
  const { flat, canEdit } = useBlogCategoryTreeViewContext()
  if (!canEdit) {
    return <BusyButtonLink icon="arrow-right" text="Move to…" disabledReason={NO_EDIT_PERMISSION_REASON} />
  }

  return (
    <Dropdown align="end">
      <Dropdown.Toggle as={LinkDropdownToggle} icon="arrow-right">
        Move to…
      </Dropdown.Toggle>

      {/* Portalled so the tree and table panes, which scroll, cannot clip the menu. */}
      <PortalDropdownMenu className="overflow-y-auto" style={{ maxHeight: '20rem' }}>
        <Dropdown.Header>Move to…</Dropdown.Header>
        {map(buildMoveToMenuModel(flat, excludedBlogCategoryIds, false), (item) => (
          <Dropdown.Item
            key={item.key}
            disabled={item.disabled}
            style={
              item.depth > 1
                ? { paddingLeft: `calc(var(--bs-dropdown-item-padding-x) + ${item.depth - 1}rem)` }
                : undefined
            }
            onClick={() => onMove(item.categoryId)}
          >
            {item.label}
          </Dropdown.Item>
        ))}
      </PortalDropdownMenu>
    </Dropdown>
  )
}
